import styles from "../../styles/common/sideCard.module.css";
import { Card, Typography, Grid } from "@mui/material";
import { toShortNumber } from "../../lib/util";
import CircularPercentage from "./CircularPercentage";

type ProposalStatProps = {
  title?: string;
  val1: number;
  val2: number;
  val3?: number;
  desc1: string;
  desc2: string;
  desc3?: string;
  valSub: number;
  valTotal: number;
  vote: boolean;
};

const ProposalStatCircleCard = (props: ProposalStatProps) => {
  return (
    <Card className={styles.card} elevation={4} sx={{ borderRadius: "10px" }}>
      <Typography gutterBottom variant="h6" component="div">
        {props.title}
      </Typography>
      <Grid container spacing={3}>
        <Grid item container>
          <Grid container className={styles.progressDescRow}>
            <Grid item>
              <Typography variant="body1">
                {!props.vote && props.desc1 + "$" + toShortNumber(props.val1)}
                {props.vote && props.desc1 + toShortNumber(props.val1, "comma")}
              </Typography>

              <Typography variant="body1">
                {!props.vote && props.desc2 + "$" + toShortNumber(props.val2)}
                {props.vote && props.desc2 + toShortNumber(props.val2, "comma")}
              </Typography>

              {props.desc3 && (
                <Typography variant="body1">
                  {!props.vote &&
                    props.desc3! + "$" + toShortNumber(props.val3!)}
                  {props.vote &&
                    props.desc3! + toShortNumber(props.val3!, "comma")}
                </Typography>
              )}
            </Grid>

            <Grid item>
              <CircularPercentage
                percent={
                  +Number(
                    Math.round((props.valSub / props.valTotal) * 10000) + "e-2"
                  ).toFixed(2)
                }
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
};

export default ProposalStatCircleCard;
